// endless-book's embeddable reader, a prebuilt copy in vendor/ (refresh: yarn update-book-embed).
// Raw CSS, not a regular import: our css-loader runs CSS Modules and would hash the .eb-embed classes.
import css from '!!raw-loader!../../../vendor/endless-book-embed/embed.css';

export { BookReader } from '../../../vendor/endless-book-embed';
export type { IBook, IBookReaderError, IBookReaderProps } from '../../../vendor/endless-book-embed';

export const BOOK_EMBED_CSS = css;
